import * as z from "zod";

export const formSchema = z.object({
  selectedWarehouse: z.string().min(1, "Please select a pickup warehouse"),
  selectedDestination: z.string().min(
    1,
    "Please select a destination warehouse",
  ),
  weight: z.number().refine(
    (val) => val > 0,
    "Please enter a valid weight",
  ),
  contents: z.string().min(1, "Please describe the freight contents"),
  // All date/time fields are nullable and optional
  pickupStartDate: z.date().nullable(),
  pickupEndDate: z.date().nullable(),
  pickupStartTime: z.string().nullable(),
  pickupEndTime: z.string().nullable(),
  dropOffStartDate: z.date().nullable(),
  dropOffEndDate: z.date().nullable(),
  dropOffStartTime: z.string().nullable(),
  dropOffEndTime: z.string().nullable(),
  bol: z.string().nullable(),
});

export type FormData = z.infer<typeof formSchema>;
